import type { DifferenceOptions } from "./DifferenceOptions";
import dateTime from "./dateTime";

export default function differenceInDays(
  dateLeft: Date,
  dateRight: Date,
  diffOptions?: DifferenceOptions,
) {
  return dateTime(dateLeft).difference(dateRight, "days", diffOptions);
}
